import { render, staticRenderFns } from "./DashAiInsights.vue?vue&type=template&id=c51a2824&"
import script from "./DashAiInsights.vue?vue&type=script&lang=js&"
export * from "./DashAiInsights.vue?vue&type=script&lang=js&"
import style0 from "./DashAiInsights.vue?vue&type=style&index=0&id=c51a2824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports